import { useCreateFlightPurchase } from 'api-hooks/order/ticket-order';
import { TicketSaleModel } from 'api-hooks/sale/ticket-sale';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { NavigationProps } from 'types';

import FlightPurchaseForm from './components/form';
import { TicketOrderFormType } from './components/form-type';

export type FlightPurchaseCreateParams = {
  flightSale?: TicketSaleModel;
  defaultValues?: TicketOrderFormType;
};

export default function FlightPurchaseCreate(
  props: NavigationProps<NavigationRoutes.FlightPurchasesCreate>,
) {
  const { mutateAsync, error } = useCreateFlightPurchase();

  const onResolve = useApprovalableEdit('flight-purchases');

  return (
    <>
      <FlightPurchaseForm
        {...props}
        flightSale={props.navigation.params?.flightSale}
        defaultValues={props.navigation.params?.defaultValues}
        renderError={
          !!error &&
          !!error.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => error.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )
        }
        onSubmit={async (input: any, form) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
